import CommunicationTable from "../../../components/selfcare/CommunicationTable";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {useSearchParams} from "react-router-dom";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";

export default function OverviewPage() {
    setTitleAndMetaDescription("Breve - Mit Hiper", "Her kan du se de breve og sms'er vi har sendt til dig.");

    const {customer} = useCustomer()
    const [searchParams] = useSearchParams()

    return <SelfcarePageContent>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Breve</h1>
            <p>Se alle de mails og sms'er, vi har sendt til dig.</p>
        </div>

        <CommunicationTable customer_id={customer.customer_id} page={Number(searchParams.get('page') ?? 1)}/>
    </SelfcarePageContent>
}
